// PET ARTIST: force legacy Shopify Inbox while Agent handoff is unavailable.
(function () {
  function removeAgentHost() {
    document.querySelectorAll('shopify-agent').forEach(function (agent) {
      agent.remove();
    });
  }

  var agentObserver = new MutationObserver(removeAgentHost);
  agentObserver.observe(document.documentElement, { childList: true, subtree: true });
  removeAgentHost();

  document.addEventListener('DOMContentLoaded', function () {
    removeAgentHost();
    agentObserver.disconnect();
  }, { once: true });
})();

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 *//**
 * Marquee Scroll - Focal 主题选取框
 * 移植自 Horizon 主题,适配 Focal 的 Custom Elements 架构
 *
 * 使用 customElements.define() 注册,与 Focal 原生架构完全兼容:
 * - 页面初次加载时自动初始化
 * - Shopify 编辑器动态添加 section 时自动初始化
 * - Shopify AJAX section rendering 时自动初始化
 *
 * 核心逻辑:
 * 1. 计算需要重复几份 items 才能填满视口宽度
 * 2. 复制整个 items 集合 N 次
 * 3. 克隆整个 content 做无缝循环
 * 4. CSS animation 驱动滚动
 * 5. 悬停减速/离开恢复
 * 6. 窗口 resize 自动重新计算
 */
class MarqueeScrollElement extends HTMLElement {
  constructor() {
    super();

    this.speedFactor = 25;
    this.originalItems = null;
    this.speedAnimation = null;
    this.lastWidth = null;
    this._initialized = false;
  }

  connectedCallback() {
    // 防止重复初始化(Shopify 编辑器可能触发多次)
    if (this._initialized) return;

    var self = this;

    // 等待子元素完全渲染后再初始化
    // 兼容 Shopify 编辑器中元素尚未完成布局计算的情况
    if (this.isConnected && this.children.length > 0) {
      this._initAfterLayout();
    } else {
      // 如果 children 还没渲染(编辑器首次添加),稍等再试
      var attempts = 0;
      var checkInterval = setInterval(function() {
        attempts++;
        var wrapper = self.querySelector('[data-marquee-items]');
        var items = wrapper ? wrapper.children : null;
        if ((items && items.length > 0) || attempts > 10) {
          clearInterval(checkInterval);
          self._initAfterLayout();
        }
      }, 100);
    }
  }

  disconnectedCallback() {
    this._cleanup();
  }

  _initAfterLayout() {
    var self = this;

    // 使用 requestAnimationFrame 确保布局计算完成
    requestAnimationFrame(function() {
      self._init();
    });
  }

  _init() {
    if (this._initialized) return;

    this.speedFactor = Number(this.getAttribute('data-speed-factor')) || 25;

    var itemsContainer = this.querySelector('[data-marquee-items]');
    if (!itemsContainer) return;

    var items = itemsContainer.children;
    if (!items || items.length === 0) return;

    // 保存原始 items 的快照
    this.originalItems = Array.from(items).map(function(item) {
      return { el: item, cloned: false };
    });

    this.calculateAndSetup();
    this.bindEvents();

    this._initialized = true;
  }

  /**
   * 核心: 计算+复制+启动动画
   */
  calculateAndSetup() {
    var wrapper = this.querySelector('[data-marquee-wrapper]');
    var content = this.querySelector('[data-marquee-content]');
    var itemsContainer = this.querySelector('[data-marquee-items]');
    if (!wrapper || !content || !itemsContainer) return;

    // 先恢复到原始状态(移除所有之前的副本)
    this._resetItems(itemsContainer);
    if (!this.originalItems || this.originalItems.length === 0) return;

    var marqueeWidth = this.offsetWidth;
    if (marqueeWidth === 0) return;

    // 计算原始 items 总宽度
    var itemsWidth = 0;
    for (var i = 0; i < this.originalItems.length; i++) {
      itemsWidth += this.originalItems[i].el.offsetWidth;
    }

    // numberOfCopies = 需要几份完整 items 集合才能填满视口
    var numberOfCopies = itemsWidth === 0 ? 1 : Math.ceil(marqueeWidth / itemsWidth);

    // 在 items 容器内重复整组 items
    this._addCopies(itemsContainer, numberOfCopies);

    // 克隆整个 content 做无缝循环
    this._duplicateContent(wrapper, content);

    // 设置动画速度: 速度与副本数的平方根成正比(副本越多跑越快)
    var speed = Math.sqrt(numberOfCopies) * this.speedFactor;
    this.style.setProperty('--marquee-speed', speed + 's');

    this.lastWidth = marqueeWidth;
  }

  /**
   * 移除所有之前添加的副本,恢复到只包含原始 items
   */
  _resetItems(container) {
    while (container.lastChild !== null) {
      container.removeChild(container.lastChild);
    }
    if (this.originalItems) {
      for (var i = 0; i < this.originalItems.length; i++) {
        container.appendChild(this.originalItems[i].el);
      }
    }
  }

  /**
   * 在 items 容器内重复整组 items
   */
  _addCopies(container, totalCopies) {
    var items = this.originalItems;
    if (!items || items.length === 0 || totalCopies <= 1) return;

    for (var copyIndex = 1; copyIndex < totalCopies; copyIndex++) {
      for (var i = 0; i < items.length; i++) {
        var clone = items[i].el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
      }
    }
  }

  /**
   * 克隆整个 content div,实现无缝循环动画
   */
  _duplicateContent(wrapper, content) {
    var existingClone = wrapper.querySelector('[data-marquee-content-clone]');
    if (existingClone) {
      existingClone.remove();
    }

    var clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-marquee-content-clone', '');
    wrapper.appendChild(clone);
  }

  /**
   * 重启 CSS 动画(从 0 开始)
   */
  _restartAnimation() {
    var wrapper = this.querySelector('[data-marquee-wrapper]');
    if (!wrapper) return;

    var animations = wrapper.getAnimations();
    requestAnimationFrame(function() {
      for (var i = 0; i < animations.length; i++) {
        animations[i].currentTime = 0;
      }
    });
  }

  bindEvents() {
    var self = this;
    var slowdownTimer = null;

    // 悬停减速(带 500ms 防抖,避免鼠标划过时误触发)
    this.addEventListener('pointerenter', function() {
      clearTimeout(slowdownTimer);
      slowdownTimer = setTimeout(function() {
        self._doSlowDown();
      }, 500);
    });

    // 离开恢复速度
    this.addEventListener('pointerleave', function() {
      clearTimeout(slowdownTimer);
      slowdownTimer = null;
      self._doSpeedUp();
    });

    // 窗口 resize 重新计算
    var resizeDebounce;
    this._onResize = function() {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(function() {
        var newWidth = self.offsetWidth;
        if (newWidth !== self.lastWidth) {
          self.calculateAndSetup();
          self._restartAnimation();
        }
      }, 250);
    };
    window.addEventListener('resize', this._onResize);
  }

  _cleanup() {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
      this._onResize = null;
    }
  }

  _doSlowDown() {
    if (this.speedAnimation) return;

    var wrapper = this.querySelector('[data-marquee-wrapper]');
    if (!wrapper) return;

    var animation = wrapper.getAnimations()[0];
    if (!animation) return;

    var self = this;
    this.speedAnimation = animateValue({
      from: 1,
      to: 0,
      duration: 500,
      onUpdate: function(value) {
        animation.updatePlaybackRate(value);
      },
      onComplete: function() {
        self.speedAnimation = null;
      }
    });
  }

  _doSpeedUp() {
    var wrapper = this.querySelector('[data-marquee-wrapper]');
    if (!wrapper) return;

    var animation = wrapper.getAnimations()[0];
    if (!animation || animation.playbackRate === 1) return;

    var from = this.speedAnimation ? this.speedAnimation.current : 0;
    if (this.speedAnimation) {
      this.speedAnimation.cancel();
    }

    var self = this;
    this.speedAnimation = animateValue({
      from: from,
      to: 1,
      duration: 500,
      onUpdate: function(value) {
        animation.updatePlaybackRate(value);
      },
      onComplete: function() {
        self.speedAnimation = null;
      }
    });
  }
}

/**
 * 数值缓动动画工具
 * 使用 SmoothStep 缓动函数
 */
function animateValue(opts) {
  var from = opts.from;
  var to = opts.to;
  var duration = opts.duration;
  var onUpdate = opts.onUpdate;
  var onComplete = opts.onComplete;
  var startTime = performance.now();
  var cancelled = false;
  var currentValue = from;

  function animate(currentTime) {
    if (cancelled) return;

    var elapsed = currentTime - startTime;
    var progress = Math.min(elapsed / duration, 1);
    // SmoothStep: 3t² - 2t³
    var eased = progress * progress * (3 - 2 * progress);
    currentValue = from + (to - from) * eased;

    onUpdate(currentValue);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else if (typeof onComplete === 'function') {
      onComplete();
    }
  }

  requestAnimationFrame(animate);

  return {
    get current() {
      return currentValue;
    },
    cancel: function() {
      cancelled = true;
    }
  };
}

// 注册自定义元素 — 与 Focal 原生架构完全一致
// Focal 在 theme.js 中定义了: toggle-button, loader-button, collapsible-content 等
// 这里追加 marquee-scroll,浏览器会自动处理所有初始化
if (typeof window.customElements !== 'undefined' && !window.customElements.get('marquee-scroll')) {
  window.customElements.define('marquee-scroll', MarqueeScrollElement);
}
